export const STORE_CHANGE_STORE_STATE = 'STORE_CHANGE_STORE_STATE';

export default function setChangeStore(payload) {
  return {
    type: STORE_CHANGE_STORE_STATE,
    payload,
  };
}
